import { StoreTypography } from '../typography/StoreTypography'

import styles from './cardRibbon.module.scss'

type Props = {
  content: string | undefined
}

export const CardRibbon = ({ content }: Props) => {
  if (!content?.length) {
    return null
  }

  return (
    <div className={styles.Container}>
      <div className={styles.Shadow}>
        <StoreTypography
          tag="div"
          style="plain"
          textSize="sm"
          overrideFont="supercellTextBold"
          className={styles.Ribbon}
        >
          +{content}
        </StoreTypography>
      </div>
    </div>
  )
}
